import { useState } from "react";
import { Redirect } from "react-router";
import { setUserData, getUserData, invalidateSession } from "../helpers/Session";
import API, { getApiErrorMessage } from "../helpers/api";

const Login = () => {
  const [nim, setNim] = useState("");
  const [password, setPassword] = useState("");
  const [onProgress, setProgress] = useState(false);
  const [message, setMessage] = useState("Pakai Akun SIAM Ya!");

  const handleSubmit = async () => {
    if (onProgress) return;

    if (nim.length !== 15 || password.length < 6) {
      setMessage("Format Inputan Salah");
      return;
    }

    if (nim.substring(2, 6) !== "5150") {
      setMessage("Khusus SGE FILKOM ya");
      return;
    }

    setProgress(true);
    setMessage("Mengautentikasi...");

    try {
      const loginResponse = await API.post("/users/login", { nim, password });
      const loginStatus = loginResponse.data?.status;

      if (loginStatus !== "ok" && loginStatus !== "success") {
        throw new Error(loginResponse.data?.msg || "Credentials incorrect");
      }

      const userData = loginResponse.data?.data || {};
      const adminResponse = await API.get(`/is_admin/${userData.nim || nim}`, {
        headers: userData.token
          ? { Authorization: `Bearer ${userData.token}` }
          : undefined,
      });
      const isAdmin =
        adminResponse.data?.data?.isAdmin === true ||
        adminResponse.data?.data?.is_admin === true;

      if (!isAdmin) {
        invalidateSession();
        setMessage("Bukan Admin");
        return;
      }

      setMessage("Redirecting...");
      setUserData(userData);
      window.location.reload();
    } catch (error) {
      invalidateSession();
      setMessage(getApiErrorMessage(error, "Login gagal"));
    } finally {
      setProgress(false);
    }
  };

  return (
    <>
      {getUserData().hasOwnProperty("nim") ? (
        <Redirect to="/dashboard" />
      ) : (
        <section className="relative flex min-h-screen bg-background overflow-hidden items-center justify-center p-4">
          
          {/* Decorative Background Elements */}
          <div className="absolute top-[-10%] left-[-10%] w-96 h-96 bg-primary/20 rounded-full blur-3xl" />
          <div className="absolute bottom-[-10%] right-[-10%] w-96 h-96 bg-secondary/20 rounded-full blur-3xl" />
          
          <div className="glass-card w-full max-w-4xl flex flex-col md:flex-row overflow-hidden z-10 relative">
            
            {/* Left Side: Branding */}
            <div className="md:w-5/12 bg-primary text-white p-12 flex flex-col justify-center items-center relative overflow-hidden">
              <div className="absolute inset-0 bg-[url('data:image/svg+xml,%3Csvg xmlns=\\'http://www.w3.org/2000/svg\\' width=\\'24\\' height=\\'24\\' viewBox=\\'0 0 24 24\\'%3E%3Cg fill=\\'%23ffffff\\' fill-opacity=\\'0.05\\'%3E%3Cpolygon fill-rule=\\'evenodd\\' points=\\'8 4 12 6 8 8 6 12 4 8 0 6 4 4 6 0 8 4\\'/%3E%3C/g%3E%3C/svg%3E')] opacity-30" />
              <div className="relative z-10 flex flex-col items-center">
                <img src="/assets/logo.png" alt="Logo" className="w-24 h-24 mb-6 drop-shadow-md" />
                <h1 className="text-3xl font-bold tracking-tight text-center mb-2">MOTION ADMIN</h1>
                <p className="text-primary-light text-center text-sm">SGE FILKOM 2026</p>
              </div>
            </div>

            {/* Right Side: Form */}
            <div className="md:w-7/12 p-10 md:p-14 flex flex-col justify-center bg-surface">
              <div className="mb-8">
                <h2 className="text-2xl font-bold text-text-heading mb-2">Selamat Datang 👋</h2>
                <p className="text-text-muted text-sm">{message}</p>
              </div>

              <form onSubmit={(e) => { e.preventDefault(); handleSubmit(); }} className="space-y-6">
                <div>
                  <label className="block text-sm font-medium text-text-body mb-2">NIM</label>
                  <input
                    className="w-full px-4 py-3 bg-background border border-slate-200 rounded-xl input-ring text-text-heading"
                    name="nim"
                    type="text"
                    required
                    autoFocus
                    pattern="[0-9]{15}"
                    placeholder="Masukkan NIM Anda"
                    value={nim}
                    onChange={(e) => setNim(e.target.value)}
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-text-body mb-2">Password</label>
                  <input
                    className="w-full px-4 py-3 bg-background border border-slate-200 rounded-xl input-ring text-text-heading"
                    name="password"
                    type="password"
                    pattern=".{6,}"
                    required
                    placeholder="Masukkan Password SIAM"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                </div>

                <div className="pt-4">
                  <button
                    type="submit"
                    className="w-full flex justify-center items-center py-3 px-8 bg-primary hover:bg-primary-dark text-white rounded-xl shadow-soft font-medium transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-primary/50 disabled:opacity-70 disabled:cursor-not-allowed"
                    disabled={onProgress}
                  >
                    {onProgress ? (
                      <>
                        <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                        </svg>
                        Memproses...
                      </>
                    ) : "Masuk ke Dashboard"}
                  </button>
                </div>
              </form>
            </div>

          </div>
        </section>
      )}
    </>
  );
};

export default Login;
